import FullPageLayout from "../../../../templates/FullPageLayout";
import { Button, Col, Row, Card, Form, Switch, Checkbox } from "antd";
import { Controller, useForm } from "react-hook-form";
import { NeedHelp } from "../../../../atoms/CustomIcons";
import { useEffect, useState } from "react";
import {
  DateField,
  InputField,
  SelectField,
  TextEditor,
} from "../../../../atoms/FormFields";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../config/hooks";
import { getPropertyFormData } from "../../../Properties/ducks/actions";
import UploadFullMultiple from "../../../../atoms/UploadPhoto/UploadFullMultiple";

interface FormValues {
  name: string;
  file_required: boolean;
  property: string;
  priority: string;
  due_date: string[];
  details: string;
  source: string[];
  responsible_for_account: string;
}

export default function AddTask() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const [checklistFile, setChecklistFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [attachFiles, setAttachFiles] = useState(false);
  const [attachLocation, setAttachLocation] = useState(false);
  const [scheduleNow, setScheduleNow] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const [previewImage, setPreviewImage] = useState<{
    file: string;
    imagePreviewUrl: string | null;
  }>({ file: "", imagePreviewUrl: null });
  const [modalPreviewImage, setModalPreviewImage] = useState<{
    file: string;
    imagePreviewUrl: string | null;
  }>({ file: "", imagePreviewUrl: null });

  const saveUpload = () => {
    setLoading(true);
    setPreviewImage({ ...modalPreviewImage });
    setLoading(false);
  };

  useEffect(() => {
    if (companyId) {
      dispatch(getPropertyFormData(companyId));
    }
  }, [companyId, dispatch]);

  const onSubmit = (val: FormValues) => {
    setLoading(true);

    console.log("Form submitted with values:", val);
  };

  return (
    <FullPageLayout loading={loading}>
      <Form
        className="propertyForm"
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        <Button className="btn-sm fixedTopBtn">
          <NeedHelp /> Need help?
        </Button>

        <div style={{ paddingBottom: 80 }}>
          <Row gutter={8} style={{ width: "672px" }}>
            <Col span={24}>
              <div
                className="title"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <h2> New task </h2>
                  <p>
                    Additional work item to a regular service, which crews can
                    take care of.
                  </p>
                </div>
              </div>
            </Col>

            <Col span={24}>
              <Card>
                <Row gutter={20}>
                  <Col span={24}>
                    <InputField
                      fieldName="name"
                      label="Task name"
                      control={control}
                      defaultValue=""
                      iProps={{
                        placeholder: "Enter task name...",
                      }}
                      isRequired
                      rules={{
                        required: "Task name is required.",
                      }}
                      validate={errors.name && "error"}
                      validMessage={errors.name && errors.name.message}
                    />
                  </Col>
                  <Col span={24}>
                    <SelectField
                      fieldName="property"
                      label="Property"
                      control={control}
                      selectOption={[]}
                      iProps={{
                        placeholder: "Select property",
                      }}
                      isRequired
                      rules={{
                        required: "Property is required.",
                      }}
                      validate={errors.property && "error"}
                      validMessage={errors.property && errors.property.message}
                      tooltipTitle="Select property"
                    />
                  </Col>
                  <Col span={12}>
                    <SelectField
                      fieldName="priority"
                      label="Priority"
                      control={control}
                      selectOption={[]}
                      iProps={{
                        placeholder: "None",
                      }}
                      tooltipTitle="Priority"
                    />
                  </Col>
                  <Col span={12}>
                    <DateField
                      fieldName="due_date"
                      label="Due date"
                      control={control}
                    />
                  </Col>
                  <Col span={24}>
                    <TextEditor
                      fieldName="details"
                      label="Details"
                      control={control}
                      tooltipTitle="Details tooltip"
                    />
                  </Col>
                  <Col span={24}>
                    <SelectField
                      fieldName="source"
                      label="Source"
                      control={control}
                      selectOption={[]}
                      iProps={{
                        placeholder: "Select who came up with this task",
                      }}
                    />
                  </Col>
                </Row>
              </Card>
              <Card className="switchBoxCard">
                <Row gutter={[20, 8]}>
                  <Col span={24}>
                    <div className="switchBoxBold">
                      <Switch
                        onChange={() => setAttachFiles(!attachFiles)}
                        checked={attachFiles}
                      />
                      Attach files
                    </div>
                  </Col>
                  {attachFiles && (
                    <>
                      <Col span={24}>
                        <UploadFullMultiple
                          saveUpload={saveUpload}
                          loading={false}
                          onImageDelete={() => null}
                          previewImage={previewImage}
                          checklistFile={checklistFile}
                          modalPreviewImage={modalPreviewImage}
                          setChecklistFile={setChecklistFile}
                          setPreviewImage={setPreviewImage}
                          setModalPreviewImage={setModalPreviewImage}
                          infoTextUploader="The picture helps others identify this property. It’s optional."
                        />
                      </Col>

                      <Col span={24}>
                        <div className="probabilityTitle">
                          <span className="not_specified">
                            <Controller
                              name="file_required"
                              control={control}
                              render={({ field }) => (
                                <Checkbox
                                  {...field}
                                  checked={field.value}
                                  onChange={(e) =>
                                    field.onChange(e.target.checked)
                                  }
                                >
                                  <div
                                    className="required_text"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "flex-start",
                                      flexDirection: "column",
                                      paddingLeft: "10px",
                                    }}
                                  >
                                    <h4
                                      style={{
                                        fontSize: "14px",
                                        lineHeight: "20px",
                                        fontWeight: "500",
                                        marginBottom: "2px",
                                      }}
                                    >
                                      Requires proof of completion
                                    </h4>
                                    <p
                                      style={{
                                        fontSize: "11px",
                                        lineHeight: "14px",
                                        fontWeight: "400",
                                        marginBottom: "0px",
                                        color: "#98A3A9",
                                      }}
                                    >
                                      The crew leader will be required to take a
                                      photo or video upon visit completion.
                                    </p>
                                  </div>
                                </Checkbox>
                              )}
                            />
                          </span>
                        </div>
                      </Col>
                    </>
                  )}
                </Row>
              </Card>

              <Card className="switchBoxCard">
                <Row gutter={20}>
                  <Col span={24}>
                    <div className="switchBoxBold">
                      <Switch
                        onChange={() => setAttachLocation(!attachLocation)}
                        checked={attachLocation}
                      />
                      Attach location
                    </div>
                  </Col>
                  {attachLocation && (
                    <Col span={24}>
                      <img src="/images/work-orders/location.png" alt="" />
                    </Col>
                  )}
                </Row>
              </Card>

              <Card className="switchBoxCard">
                <div className="switchBoxBold">
                  <Switch
                    onChange={() => setScheduleNow(!scheduleNow)}
                    checked={scheduleNow}
                  />
                  Schedule now
                </div>
              </Card>
            </Col>
          </Row>

          <div className="fixed_btm_card">
            <Card>
              <div className="centered">
                <Button
                  htmlType="button"
                  className="outlined-btn"
                  onClick={() => navigate(`/tasks/${companyId}`)}
                >
                  Cancel
                </Button>
                <div style={{ display: "flex", gap: "16px" }}>
                  {/* <Button
                    htmlType="button"
                    className="outlined-btn"
                    type="primary"
                    // onClick={saveAddMore}
                  >
                    Save & add one more
                  </Button> */}
                  <Button htmlType="submit" type="primary" className="mint-btn">
                    Create task
                  </Button>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </Form>
    </FullPageLayout>
  );
}
